/* Packages */
import React from 'react';

export default function ConversionFlowFieldHeader(props) {
    const { colClassName, field, id } = props;
    const { config } = field;
    const { title, intro } = config;

    return (
        <>
            <div className={`${colClassName}`}>
                {title && (
                    <p className={`flow__header-title flow__header-title--${id}`}>
                        {title}
                    </p>
                )}
                {intro && (
                    <p className={`flow__header-intro flow__header-intro--${id}`}>
                        {intro}
                    </p>
                )}
            </div>
        </>
    );
}
